import {
  QuestionBubbleHeader,
  QuestionBubbleLabel,
  NormalQuestionBubble,
} from "@/Shared/Components/QuestionBubble";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

function QuotesEstimatedEarliestDeliveryDateQuestionBubble() {
  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>Earliest Delivery Date</QuestionBubbleHeader>
          <QuestionBubbleLabel>
            {/* gap 4 == the 16px that used to sit between the two paragraphs */}
            <Stack gap={4}>
              <div>
                Most carriers provide an estimated earliest delivery date when
                quoting. Assuming everything goes perfectly, this is when your
                freight will deliver.
              </div>
              <div>
                This is updated periodically in-transit with the latest
                information from the carrier.
              </div>
            </Stack>
          </QuestionBubbleLabel>
        </>
      }
      learnMoreUrl="https://help.freightsimple.com/using-freightsimple/tracking/when-will-my-shipment-deliver"
    />
  );
}
export default QuotesEstimatedEarliestDeliveryDateQuestionBubble;
